/**
 * DescriptionClassification element.
 * Renders duration (VOD only), the commercial score (when present), and
 * parental age rating side by side.
 */
import AgeCode from '../ageCode/ageCode';
import Container from '@components/atoms/container/descriptionClassificationContainer';
import DescriptionContext from '@shared/components/utils/context/descriptionContext';
import DurationText from '@components/atoms/text/classificationDurationText';
import Score from '../rating/score';
import { useContext, useMemo } from 'react';

/**
 * Displays classification UI for the current detail asset: duration (VOD
 * only), score, and age code.
 */
export default function DescriptionClassification() {
  const { asset, metadata } = useContext(DescriptionContext);
  const duration = useMemo(() => {
    const duration =
      asset?.channel?.isFast && asset?.getDuration && asset.getDuration();
    return duration;
  }, [asset]);

  return (
    <Container>
      {duration ? <DurationText>{duration}</DurationText> : null}
      <Score score={metadata?.commercialScoreText} />
      <AgeCode
        ageCode={metadata?.ageCode}
        margin={!!metadata?.commercialScoreText}
      />
    </Container>
  );
}
